import React from 'react';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { IImageViewerProps } from './document-viewer-modal.types';

export const ImageViewer: React.FC<IImageViewerProps> = ({ url, alt }) => {
  return (
    <div className="flex items-center justify-center w-full max-h-[80vh] overflow-auto p-4">
      <Zoom>
        <img
          src={url}
          alt={alt}
          className="max-w-full max-h-[75vh] object-contain"
          style={{
            imageRendering: 'crisp-edges',
          }}
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = '';
            target.alt = 'Failed to load image';
          }}
        />
      </Zoom>
    </div>
  );
};
